import React from 'react';
import { useTranslation } from 'react-i18next';
import { User } from '@ktag/commons';
import { MapPoint } from '@agissc/ktag-map';
import { Link } from '@ktag/styleguide/dist/react';
import { AuthenticatedUserRequired } from '../../../utils/auth/AuthenticatedUserRequired';
import { useTracking } from '../../../utils/tracking/TrackingContext';

const projectUID = '78a1178f-23be-4a46-b891-6a6cf35dd379';

const createInfra3dUrl = (identifyCoordinate: MapPoint) => {
  const jumpTo = JSON.stringify({
    easting: identifyCoordinate.x,
    northing: identifyCoordinate.y,
    epsg: 2056,
  });

  const redirectUri = `/edit/?projectUID=${projectUID}&jumpTo=${jumpTo}`;

  return `https://app.infra3d.com/login/tenant/ktag/?redirect_uri=${encodeURIComponent(
    redirectUri,
  )}`;
};

const hasRole = (user: User, role: string): boolean =>
  user.roles.some((userRole) => userRole.includes(role));

const hasAgobisAccess = (user: User): boolean => hasRole(user, 'IDM_AGIS_AGOBIS_LINK');
const hasInfra3dAccess = (user: User): boolean =>
  hasRole(user, 'IDM_AGIS_BVU_ATB_INFRA3DROAD_USERS');

interface IdentifyApplicationLinksProps {
  egrid: string;
  agobisLink: string;
  identifyCoordinate: MapPoint;
}

const IdentifyApplicationLinks = ({
  egrid,
  agobisLink,
  identifyCoordinate,
}: IdentifyApplicationLinksProps) => {
  const { t } = useTranslation('agisviewer');
  const { Tracking } = useTracking();

  const infra3dUrl = createInfra3dUrl(identifyCoordinate);
  const oerebUrl = `https://apps.geo.ag.ch/oereb/client/?egrid=${egrid}`;

  return (
    <div className="anwendungen">
      <div>{t('applications')}</div>
      <Link
        text="ÖREB"
        url={oerebUrl}
        openNewWindow
        additionalClassNames="form__actionslink"
        onClick={() => Tracking.Identify.clickAppLink('ÖREB')}
      />
      <AuthenticatedUserRequired filter={hasAgobisAccess}>
        <Link
          text="AGOBIS"
          url={agobisLink}
          openNewWindow
          additionalClassNames="form__actionslink"
          onClick={() => Tracking.Identify.clickAppLink('AGOBIS')}
        />
      </AuthenticatedUserRequired>
      <AuthenticatedUserRequired filter={hasInfra3dAccess}>
        <Link
          text="Infra3D"
          url={infra3dUrl}
          openNewWindow
          additionalClassNames="form__actionslink"
          onClick={() => Tracking.Identify.clickAppLink('Infra3D')}
        />
      </AuthenticatedUserRequired>
    </div>
  );
};

export default IdentifyApplicationLinks;
